import "bootstrap/dist/css/bootstrap.min.css"
import React from 'react';
import './App.css';


class NameForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      usuario: '',
      contraseña:'',
      json: []
  };


    this.handleid = this.handleid.bind(this);
   
    this.handleamount = this.handleamount.bind(this);
   

  }

  handleid(e) { this.setState({id: e.target.value})}
 

  handleamount (e) {this.setState({amount: e.target.value})}

  handleSubmit = async (event) => {
    // alert('A name was submitted: ' + this.state.value);
    event.preventDefault();
     try {
        let config = {
          method: "POST",
          headers: {
            "Accept": " application/json",
            "Content-Type": " application/json"
          },
          body: JSON.stringify ({
            cedula: this.state.id,
           
            acceso: this.state.amount,
            
          })

        }
        // console.log(config)
        let res = await fetch ("https://laboratoriopatologiaahf.herokuapp.com/api/data", config)
        let json = await res.json()
        
        this.setState({
          json
        })
        // console.log(json)
        
     } catch (error) {
       
     }
    
  }

  render() {



    
    return (
      <div className="bodyc">
    <div className="containerPrincipal">
      <div className="containerSecundario">
        <h3>Ingreso Medico</h3>
        <hr/>
      <form onSubmit={this.handleSubmit}>
        <label> Cédula:
      <input type="text" className="form-control" name="usuario" value={this.state.usuario.value} onChange={(e)=> this.handleid(e)} placeholder="Cedula del Paciente" required/>
        </label>
        <br/>
        <br/>
        
        <label> Acceso:
      <input type="text" className="form-control" name="clave" value={this.state.contraseña.value} onChange={(e)=> this.handleamount(e)} placeholder="Ingrese su Acceso" required/>
        </label>
        <br/>
        <input type="submit" value="Acceder" className="btn btn-primary"/>
      </form>
      </div>
    
      </div>
      
      
      
      <div className="containerPrincipa">
      <div className="container mt-5" align="center">
     
      <h4>Resultados pacientes</h4>
    
     
          <table className="table table-bordered" width="50%">
            <thead className="table-dark">
              <tr>
                <th scope="col">Cédula</th>
                <th scope="col">Nombre</th>
                <th scope="col">Apellido</th>
                <th scope="col">Fecha</th>
                <th scope="col">Link de Descarga</th>
                <th scope="col">Error</th>
                <th scope="col">Detalle</th>
                
              </tr>
            </thead> 
            <tbody>
          {this.state.json.map(person => (
              <tr>
               
                <td>{person.cedula}</td>
                <td>{person.nombre}</td>
                <td>{person.apellido}</td>
                <td>{person.fecha}</td>
                <td><a href={person.url} target="_blank">{person.cedula}</a></td>
                <td>{person.Error}</td>
                <td>{person.Detalle}</td>

                </tr>
            ))}

            </tbody>
 
          </table>
          
  
      <section className="mt-1 mb-5">
        <div align="center">
            Desarrollado por Gexperts
        </div> 
      </section>
      </div>
    

     
    </div>

    </div>
    );
  }
}




export default NameForm;